import { apiClient } from './client';

export interface LinkTokenResponse {
  link_token: string;
  expiration: string;
}

export interface ExchangePublicTokenRequest {
  public_token: string;
}

export interface ExchangePublicTokenResponse {
  ok: boolean;
  message: string;
}

export interface PaymentProfileResponse {
  has_linked_account: boolean;
  provider?: string;
  status?: string;
}

export interface BankAccount {
  id: string;
  institution_name: string;
  account_name: string;
  mask: string;
  account_type: string;
  status: string;
  is_default: boolean;
  verified_at?: string;
  created_at: string;
  updated_at: string;
}

export interface BankAccountsResponse {
  accounts: BankAccount[];
}

export interface SyncBankAccountsResponse {
  accounts: BankAccount[];
  synced_at: string;
}

export interface SetDefaultBankAccountRequest {
  bank_account_id: string;
}

export interface SetDefaultBankAccountResponse {
  ok: boolean;
  default_bank_account_id: string;
}

export interface DisableBankAccountRequest {
  reason_code: string;
  reason_text?: string;
  replacement_default_bank_account_id?: string;
}

export interface DisableBankAccountResponse {
  ok: boolean;
}

export const paymentsEndpoints = {
  // Create Plaid link token for current user
  createLinkToken: () =>
    apiClient.post<LinkTokenResponse>('/api/payments/link_token'),

  // S-B6: Create Plaid link token for update mode (reconnecting)
  createUpdateLinkToken: () =>
    apiClient.post<LinkTokenResponse>('/api/payments/link_token/update'),

  // Exchange Plaid public token after successful Link flow
  exchangePublicToken: (publicToken: string) =>
    apiClient.post<ExchangePublicTokenResponse>('/api/payments/exchange_public_token', {
      public_token: publicToken,
    }),

  // Get payment profile status
  getProfile: () =>
    apiClient.get<PaymentProfileResponse>('/api/payments/profile'),

  // S-B4: List bank accounts
  listBankAccounts: () =>
    apiClient.get<BankAccountsResponse>('/api/payments/bank_accounts'),

  // S-B4: Sync bank accounts from provider
  syncBankAccounts: () =>
    apiClient.post<SyncBankAccountsResponse>('/api/payments/bank_accounts/sync'),

  // S-B5: Set default bank account
  setDefaultBankAccount: (bankAccountId: string) =>
    apiClient.post<SetDefaultBankAccountResponse>('/api/payments/bank_accounts/default', {
      bank_account_id: bankAccountId,
    }),

  // S-B7: Disable bank account
  disableBankAccount: (bankAccountId: string, request: DisableBankAccountRequest) =>
    apiClient.post<DisableBankAccountResponse>(`/api/payments/bank_accounts/${bankAccountId}/disable`, request),
};
